import { FormsArchiveFilterTableStatus, FormsFilterTableStatus } from 'app-constants';

export const FORM_TABS = {
  ...FormsFilterTableStatus,
  ...FormsArchiveFilterTableStatus,
  Completed: 'Completed',
  RecentlyCompleted: 'Recently Completed',
  Archive: 'Archive',
};

export const formsEmptyText = 'No Forms.';
